module.exports = __webpack_public_path__ + "static/media/daotu21.852d8117.jpg";